import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const TrainingBreadCrumbs = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	const isClassView = location && location.pathname.includes('training/class')
	const isEnrollmentView = location && location.pathname.includes('/enrollment')

	const getCrumb = () => {
		if (location && location.pathname.includes('training/schedule'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Training Schedule
				</NavLink>
			)

		if (location && location.pathname.includes('training/calendar'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Training Calendar
				</NavLink>
			)
	}

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>

			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/schedule`}>
				Training /
			</NavLink>

			{isClassView && !isEnrollmentView && (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Class Details
				</NavLink>
			)}

			{isEnrollmentView && (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Enrollment Details
				</NavLink>
			)}

			{getCrumb()}
		</div>
	)
}

export default TrainingBreadCrumbs
